export enum EntityTableColumns {
  Image = "image",
  ExternalId = "externalId",
  EntityId = "entityId",
  AgeGroup = "ageGroup",
  CodeLatin = "codeLatin",
  CodeLocal = "codeLocal",
  Discipline = "discipline",
  EntityGroupId = "entityGroupId",
  Gender = "gender",
  Grade = "grade",
  InternationalReference = "internationalReference",
  NameFullLatin = "nameFullLatin",
  NameFullLocal = "nameFullLocal",
  Representing = "representing",
  Standard = "standard",
  Status = "status",
}
